module.exports = "/dist/19ebf9fdef99c0bd73e43778070e21a0.eot";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-300italic.eot
// module id = 11
// module chunks = 0